import { SensitiveDataFormField } from "types/Models/sensitiveData";

export const getSensitiveDataPrimaryField = (
  fields: SensitiveDataFormField[] = []
): SensitiveDataFormField | null =>
  fields.find(({ is_primary_value }) => is_primary_value) || null;
